// links for 'other' websites & email
  export const gitLink = 'https://github.com/Stevens-Mark'
  export const linkedInLink ='https://www.linkedin.com/in/markspstevens/'
  export const mail ='mailto:markspstevens@yahoo.co.uk'

// list of 'tech' icons with their paths where the png, svg, jpg is stored
export const techIconList = 
		[ 
			{	"id": "accessibility", 
				"path": "../images/techIcons/accessibility.svg",
				"alt": "W3C-WCAG" },

			{ "id": "bootstrap", 
				"path": "../images/techIcons/bootstrap.svg",
				"alt": "Bootstrap" },

			{ "id": "css", 
				"path": "../images/techIcons/css.svg",
				"alt": "CSS3" },

			{ "id": "figma", 
				"path": "../images/techIcons/figma.svg",
				"alt": "Figma" },

      { "id": "firebase", 
        "path": "../images/techIcons/firebase.svg",
        "alt": "Fire Base" },
      
			{ "id": "github", 
				"path": "../images/techIcons/github.svg",
				"alt": "Github" },

			{ "id": "html", 
				"path":	"../images/techIcons/html5.svg",
				"alt": "HTML5" },

			{ "id": "jest", 
				"path": "../images/techIcons/jest.svg",
				"alt": "Jest" },

			{ "id":"javascript", 
				"path": "../images/techIcons/javascript.svg",
				"alt": "JavaScript" },

			{ "id": "jsdoc", 
				"path": "../images/techIcons/JSDoc.webp",
				"alt": "JSDoc" },

      { "id": "mongodb", 
        "path": "../images/techIcons/mongodb.svg",
        "alt": "MongoDB" },

      { "id": "mysql", 
        "path": "../images/techIcons/mysql.webp",
        "alt": "MySQL" },

      { "id": "next", 
      "path": "../images/techIcons/nextjs.svg",
      "alt": "Next.js" },
			
      { "id": "notion", 
        "path": "../images/techIcons/notion.svg",
        "alt": "Notion" },

			{ "id": "npm", 
        "path": "../images/techIcons/npm.svg",
        "alt": "NPM" },

			{ "id": "photoshop", 
        "path": "../images/techIcons/photoshop.svg",
        "alt": "PhotoShop" }, 
			        
      { "id": "php", 
        "path": "../images/techIcons/php.svg",
        "alt": "PHP" },

			{ "id": "react", 
				"path": "../images/techIcons/react.svg",
				"alt": "React" },

			{ "id": "recharts", 
				"path":  "../images/techIcons/recharts.webp",
				"alt": "Recharts" },

			{ "id": "redux", 
				"path": "../images/techIcons/redux.svg",
				"alt": "Redux",
				"title": "Redux" },

			{ "id": "sass", 
				"path": "../images/techIcons/sass.svg",
				"alt": "SaSS" },

			{ "id": "styledcomponents", 
				"path": "../images/techIcons/styled.webp",
				"alt": "Styled Components" },

			{ "id": "swagger", 
				"path": "../images/techIcons/swagger-green.svg",
				"alt": "Swagger" },

      { "id": "tables", 
        "path": "../images/techIcons/tables.svg",
        "alt": "React Tables" },

      { "id": "tailwind", 
        "path": "../images/techIcons/tailwind.svg",
        "alt": "Tailwind" },

			{ "id": "usecase", 
				"path": "../images/techIcons/usecase.svg",
				"alt": "Use Case Diagrams" },

			{ "id": "wordpress", 
			"path": "../images/techIcons/wordpress.svg",
			"alt": "WordPress" },
	]
